<div class="card" *ngIf="user">
    <ul class="list-group">
        <li class="list-group-item"><strong>E-mail: </strong>{{user.email}}</li>
        <li class="list-group-item"><strong>Imię i nazwisko: </strong>{{user.name}} {{user.surname}}</li>
        <li class="list-group-item"><strong>Numer telefonu: </strong>{{user.phoneNumber}}</li>
    </ul>
</div>